import Backbone from 'backbone'
import template from './save-required-prompt.hbs'

var SaveRequiredPrompt = Backbone.View.extend({

	className: 'dialog-message',

	events: {
		'click .button-primary': 'save'
	},

	render: function() {
		this.$el.empty().append(template())
		return this
	},

	save: function() {
		this.trigger('save')
	}

})

export default SaveRequiredPrompt

SaveRequiredPrompt.__filename__ = 'dashboards/edit/save-required-prompt.js'
